<template>
    <div>
        <h1>Background</h1>
        <p>Your mission is to build the perfect serverless kitchen in the cloud!</p>
        <p>The kitchen will have an inventory of <i>ingredients</i>.</p>
        <p>It will also have <i>recipes</i> with instructions and required ingredients.</p>
        <p>Given that there are enough ingredients, it can also bake the delicios recipes, and by doing so consume ingredients.</p>
        <p>If you are running out of ingredients, there is of course an endpoint for delivering new ingredients!</p>
        <p>The entire solution consists of a backend <i>API</i>, a frontend <i>GUI</i>, and of course a <i>test suite</i>.</p>
        <p>If you're up for it, you can have your beautiful creation hosted <i>serverless</i> in the cloud. I will tell you how to get started.</p>
        <h3>Choose your track</h3>
        <p>You can either do one of the tracks, or why not do them all and become a Full-stack Developer? Both the frontend and backend can be run <i>locally</i> or in the <i>cloud</i>.</p>
        <LinkBox>
            <li><router-link to="/backend">Goto: Build backend</router-link></li>
            <li><router-link to="/frontend">Goto: Build frontend</router-link></li>
            <li><router-link to="/test">Goto: Build automated test</router-link></li>
        </LinkBox>
        <p>Are you up for the challenge?</p>
    </div>
</template>

<script>
import LinkBox from '@/components/LinkBox.vue'

export default {
    name: 'intro',
    components: {
        LinkBox
    }
}
</script>
